import React, { useEffect, useState } from 'react'

import { Link, useParams, useLocation } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import GitHubIcon from '@material-ui/icons/GitHub';
import Box from '@material-ui/core/Box';
import MuiLink from '@material-ui/core/Link';
import IconButton from '@material-ui/core/IconButton';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import SettingsIcon from '@material-ui/icons/Settings';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import PieChartIcon from '@material-ui/icons/PieChart';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';

import GeneralLayout from './GeneralLayout'
import Page from '../components/Page';


const useStyles = makeStyles({
  stickToBottom: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
  },
});


function RepoLayout({ children }) {

  const { userName, repoName } = useParams()

  const [page, setPage] = useState(0)
  const classes = useStyles();
  const location = useLocation()

  const repoUrl = `/${userName}/${repoName}`

  // Tab switching
  useEffect(() => {
    switch (location.pathname.substring(location.pathname.lastIndexOf('/') + 1)) {
      case "shares":
        setPage(0);
        break;
      case "tasks":
        setPage(1);
        break;
      case "management":
        setPage(2);
        break;
      case "settings":
        setPage(3);
        break;
      default:
        break
    }

  }, [location])

  return (
    <GeneralLayout>

      <Container>
        {/* Repo title and link */}
        <br />
        <div align="left">
          <IconButton
            component={MuiLink}
            style={{ textDecoration: 'none', color: 'inherit' }}
            href={`https://github.com/${userName}/${repoName}`}
          >
            <GitHubIcon fontSize="large" />
          </IconButton>

          <Box display="inline" paddingRight={2} />

          <Typography display="inline" variant="h5" >
            {userName} / <b>{repoName}</b>
          </Typography>
        </div>

        {/* Page contents */}
        <Page title={`${userName}/${repoName} - GitShares`}>
          {children}
        </Page>
      </Container>

      {/* Bottom navigation for the repo */}
      <BottomNavigation
        value={page}
        onChange={(event, newValue) => {
          setPage(newValue);
        }}
        showLabels
        className={classes.stickToBottom}
      >
        <BottomNavigationAction label="Shares" icon={<PieChartIcon />} component={Link} to={`${repoUrl}`} />
        <BottomNavigationAction label="Tasks" icon={<FormatListNumberedIcon />} component={Link} to={`${repoUrl}/tasks`} />
        <BottomNavigationAction label="Management" icon={<EqualizerIcon />} component={Link} to={`${repoUrl}/management`} />
        <BottomNavigationAction label="Settings" icon={<SettingsIcon />} component={Link} to={`${repoUrl}/settings`} />
      </BottomNavigation>

    </GeneralLayout>
  )
}

export default RepoLayout
